/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.424
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { SurveyTypeBaseAllBaseReadDictAllDictRead } from '../model/surveyTypeBaseAllBaseReadDictAllDictRead';
// @ts-ignore
import { SurveyTypeBaseAllBaseWriteDictAllDictWrite } from '../model/surveyTypeBaseAllBaseWriteDictAllDictWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface ApiSurveyTypesGetCollectionSurveyTypeCollectionRequestParams {
    id?: string;
    id2?: Array<string>;
    name?: string;
    orderId?: string;
    orderName?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface ApiSurveyTypesGetItemSurveyTypeItemRequestParams {
    id: string;
}

export interface ApiSurveyTypesPatchItemSurveyTypeItemRequestParams {
    id: string;
    /** The updated SurveyType resource */
    surveyType?: SurveyTypeBaseAllBaseWriteDictAllDictWrite;
}

export interface ApiSurveyTypesPostCollectionSurveyTypeCollectionRequestParams {
    /** The new SurveyType resource */
    surveyType?: SurveyTypeBaseAllBaseWriteDictAllDictWrite;
}

export interface ApiSurveyTypesPutItemSurveyTypeItemRequestParams {
    id: string;
    /** The updated SurveyType resource */
    surveyType?: SurveyTypeBaseAllBaseWriteDictAllDictWrite;
}


@Injectable({
  providedIn: 'root'
})
export class SurveyTypeService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Retrieves the collection of SurveyType resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSurveyTypesGetCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesGetCollectionSurveyTypeCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesGetCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesGetCollectionSurveyTypeCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<SurveyTypeBaseAllBaseReadDictAllDictRead>>>;
    public apiSurveyTypesGetCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesGetCollectionSurveyTypeCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<SurveyTypeBaseAllBaseReadDictAllDictRead>>>;
    public apiSurveyTypesGetCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesGetCollectionSurveyTypeCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        const id2 = requestParameters?.id2;
        const name = requestParameters?.name;
        const orderId = requestParameters?.orderId;
        const orderName = requestParameters?.orderName;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (id2) {
            id2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id[]');
            })
        }
        if (name !== undefined && name !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>name, 'name');
        }
        if (orderId !== undefined && orderId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderId, 'order[id]');
        }
        if (orderName !== undefined && orderName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderName, 'order[name]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/survey_types`;
        return this.httpClient.request<Array<SurveyTypeBaseAllBaseReadDictAllDictRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a SurveyType resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSurveyTypesGetItemSurveyTypeItem(requestParameters?: ApiSurveyTypesGetItemSurveyTypeItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<SurveyTypeBaseAllBaseReadDictAllDictRead>;
    public apiSurveyTypesGetItemSurveyTypeItem(requestParameters?: ApiSurveyTypesGetItemSurveyTypeItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesGetItemSurveyTypeItem(requestParameters?: ApiSurveyTypesGetItemSurveyTypeItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesGetItemSurveyTypeItem(requestParameters?: ApiSurveyTypesGetItemSurveyTypeItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSurveyTypesGetItemSurveyTypeItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/survey_types/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<SurveyTypeBaseAllBaseReadDictAllDictRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the SurveyType resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSurveyTypesPatchItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPatchItemSurveyTypeItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<SurveyTypeBaseAllBaseReadDictAllDictRead>;
    public apiSurveyTypesPatchItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPatchItemSurveyTypeItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesPatchItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPatchItemSurveyTypeItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesPatchItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPatchItemSurveyTypeItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSurveyTypesPatchItemSurveyTypeItem.');
        }
        const surveyType = requestParameters?.surveyType;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/survey_types/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<SurveyTypeBaseAllBaseReadDictAllDictRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: surveyType,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a SurveyType resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSurveyTypesPostCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesPostCollectionSurveyTypeCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<SurveyTypeBaseAllBaseReadDictAllDictRead>;
    public apiSurveyTypesPostCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesPostCollectionSurveyTypeCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesPostCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesPostCollectionSurveyTypeCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesPostCollectionSurveyTypeCollection(requestParameters?: ApiSurveyTypesPostCollectionSurveyTypeCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const surveyType = requestParameters?.surveyType;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/survey_types`;
        return this.httpClient.request<SurveyTypeBaseAllBaseReadDictAllDictRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: surveyType,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Replaces the SurveyType resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiSurveyTypesPutItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPutItemSurveyTypeItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<SurveyTypeBaseAllBaseReadDictAllDictRead>;
    public apiSurveyTypesPutItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPutItemSurveyTypeItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesPutItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPutItemSurveyTypeItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<SurveyTypeBaseAllBaseReadDictAllDictRead>>;
    public apiSurveyTypesPutItemSurveyTypeItem(requestParameters?: ApiSurveyTypesPutItemSurveyTypeItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiSurveyTypesPutItemSurveyTypeItem.');
        }
        const surveyType = requestParameters?.surveyType;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/survey_types/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<SurveyTypeBaseAllBaseReadDictAllDictRead>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: surveyType,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
